/* 
  触发：Reflect.emit('${router.path}')
  监听：Reflect.on(()=>{
    })
*/
class Mirror {
  constructor() {
    this.event = [];
  }
  emit(key, param = null, url) {
    if (!key) return;
    let execute = (key, param, url) => {
      localStorage.setItem(`NOTIFY_${key.toUpperCase()}`, JSON.stringify(param));
      if (this.event.length) {
        this.event.forEach((item) => {
          if (item.key === key) {
            item.callback(key, param, url);
          }
        });
      }
    };
    if (Array.isArray(key)) {
      key.forEach((k) => {
        execute(k, param, url);
      });
    } else {
      execute(key, param, url);
    }
  }
  watch(keys, callback) {
    if (!callback || !keys) return;
    if (Array.isArray(keys)) {
      keys.forEach((item) => {
        this.event.push({
          key: item,
          callback,
        });
      });
    } else {
      this.event.push({
        key: keys,
        callback,
      });
    }
  }
  once(key, callback) {
    console.log("once");
    if (!callback || !key) return;
    if (Array.isArray(key)) {
      key.forEach((item) => {
        let _key = `NOTIFY_${item.toUpperCase()}`;
        if (localStorage.getItem(_key)) {
          execute(key, _key);
        }
      });
    } else {
      let _key = `NOTIFY_${key.toUpperCase()}`;
      if (localStorage.getItem(_key)) {
        execute(key, _key);
      }
    }
    function execute(key, key2) {
      try {
        callback(key, JSON.parse(localStorage.getItem(key2)));
      } catch (e) {
        console.log(e);
        callback(key, localStorage.getItem(key2));
      }
      localStorage.removeItem(key2);
    }
  }
}

let m = new Mirror();
let dgFormDialogOpen = false;
// 监听 分发提示
m.watch(["tips_bus"], (key, param) => {
  console.log(key, param);
  setTimeout(() => {
    console.log(dgFormDialogOpen);
    if (dgFormDialogOpen) {

      m.emit("tips_el_form_dialog_open", param);
    } else {
      m.emit("tips_el_alert_box_open", param);
    }
  });
});
// 监听弹窗打开 dg-form-dialog 如： 修改发票，防止多个loding 显示
m.watch(["el_form_dialog_close", "el_form_dialog_open"], (key) => {
  dgFormDialogOpen = key == "el_form_dialog_open";
});

export default m;
